import { Fragment } from 'react';
import { colorToVariable } from '../../componentsThemeMap.js';
import { ANALYTICS_KEY } from '../../constants.js';
import { SectionComponentLayout } from '../../layout/SectionComponentLayout.js';
import { AnalyticsProvider } from '../../providers/AnalyticsProvider.js';
import { CoinbaseLogo } from '../../ui/CoinbaseLogo.js';
import '../../ui/Div/index.js';
import { ErrorBoundary } from '../../ui/ErrorBoundary.js';
import '../../ui/Image/index.js';
import { LegalDisclaimer } from '../../ui/LegalDisclaimer.js';
import '../../ui/Link/index.js';
import { Text } from '../../ui/Text.js';
import { NAVBAR_LOGO_HEIGHT, NAVBAR_LOGO_WIDTH } from '../GlobalNavbar/constants.js';
import { FooterColumn } from './FooterColumn.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Div } from '../../ui/Div/Div.js';
import { Image } from '../../ui/Image/Image.js';
import { Link } from '../../ui/Link/Link.js';
const customComponentsThemeMap = {
  default: {
    background: 'background',
    foreground: 'foreground',
    foregroundSecondary: 'foregroundMuted',
    foregroundTertiary: 'gray40'
  },
  dark: {
    background: 'foreground',
    foreground: 'background',
    foregroundSecondary: 'gray60',
    foregroundTertiary: 'gray60'
  }
};
function GlobalFooter({
  socialMediaLinks = [],
  legalDisclaimer,
  columnOne = [],
  columnTwo = [],
  columnThree = [],
  style = 'default',
  customLogo,
  customLogoHeight,
  copyrightText = 'Coinbase'
}) {
  const _customComponentsThem = customComponentsThemeMap[style],
    foreground = _customComponentsThem.foreground,
    foregroundSecondary = _customComponentsThem.foregroundSecondary,
    foregroundTertiary = _customComponentsThem.foregroundTertiary,
    background = _customComponentsThem.background;
  return /*#__PURE__*/jsx(ErrorBoundary, {
    children: /*#__PURE__*/jsx(AnalyticsProvider, {
      analyticsPrefix: "GlobalFooter",
      children: /*#__PURE__*/jsxs(SectionComponentLayout, {
        as: "footer",
        hasSpacingHorizontal: true,
        background: background,
        children: [/*#__PURE__*/jsx(Div, {
          spacingVertical: 6,
          justifyContent: "start",
          children: legalDisclaimer && /*#__PURE__*/jsx(LegalDisclaimer, {
            legalDisclaimer: legalDisclaimer
          })
        }), /*#__PURE__*/jsx(Div, {
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          children: /*#__PURE__*/jsxs(Div, {
            display: "grid",
            gridTemplateColumns: {
              sm: '1fr',
              lg: '1fr 2fr'
            },
            gap: 1,
            rowGap: 4,
            width: "100%",
            spacingBottom: 10,
            children: [/*#__PURE__*/jsxs(Div, {
              flexDirection: "column",
              gap: 1,
              children: [customLogo ? /*#__PURE__*/jsx(Div, {
                spacingBottom: 3,
                css: {
                  img: {
                    height: `${customLogoHeight ? customLogoHeight : NAVBAR_LOGO_HEIGHT}px !important`,
                    width: 'auto'
                  }
                },
                children: /*#__PURE__*/jsx(Image, {
                  alt: customLogo?.fields?.description || '',
                  src: customLogo?.fields?.file?.url || ''
                })
              }) : /*#__PURE__*/jsx(Div, {
                width: NAVBAR_LOGO_WIDTH,
                spacingBottom: 3,
                children: /*#__PURE__*/jsx(CoinbaseLogo, {})
              }), /*#__PURE__*/jsxs(Text, {
                variant: "body",
                as: "p",
                color: foregroundTertiary,
                children: ["\xA9 ", new Date().getFullYear(), " ", copyrightText]
              }), /*#__PURE__*/jsx(Div, {
                alignItems: "center",
                flexWrap: "wrap",
                children: socialMediaLinks.map(({
                  label,
                  url,
                  target
                }, index) => /*#__PURE__*/jsxs(Fragment, {
                  children: [/*#__PURE__*/jsx(Link, {
                    target: target,
                    href: url,
                    "data-qa": `${ANALYTICS_KEY.SocialMedia}${index}`,
                    children: /*#__PURE__*/jsx(Text, {
                      variant: "body",
                      as: "span",
                      color: foregroundTertiary,
                      css: {
                        ':hover': {
                          color: colorToVariable('primary')
                        }
                      },
                      children: label
                    })
                  }), index !== socialMediaLinks.length - 1 && /*#__PURE__*/jsx(Text, {
                    variant: "body",
                    as: "span",
                    spacingHorizontal: 0.5,
                    color: foregroundTertiary,
                    children: "\u2022"
                  })]
                }, index))
              })]
            }), /*#__PURE__*/jsx(Div, {
              display: "grid",
              columnGap: 4,
              gridTemplateColumns: {
                sm: '1fr',
                md: '1fr 1fr',
                lg: '1fr 1fr 1fr'
              },
              children: [columnOne, columnTwo, columnThree].map((column, index) => {
                return /*#__PURE__*/jsx(AnalyticsProvider, {
                  analyticsPrefix: `${ANALYTICS_KEY.Column}${index}`,
                  children: /*#__PURE__*/jsx(FooterColumn, {
                    column: column,
                    foreground: foreground,
                    foregroundSecondary: foregroundSecondary
                  })
                }, index);
              })
            })]
          })
        })]
      })
    })
  });
}
export { GlobalFooter, customComponentsThemeMap };
//# sourceMappingURL=GlobalFooter.js.map
